import * as types from '../actiontypes';
import env from '../../util/env';
import {
	createApiAction,
	deleteAnnotationUrl,
	deleteDocumentUrl,
	GetAllDocumentsUrl,
	patchAnnotationUrl
} from '../apiUrls';
import {documentSortingOrder, updateAnnotationAction} from '../../util/uiconstants';

export const getAllDocuments = (
	storeKey,
	engagementId,
	documentCategoryName,
	filteredEntityIdInt,
	filteredEntityType,
	documentTypeIdList,
	filteredEntityIdGuid,
	orderBy = documentSortingOrder.documentName,
	includeComments = true,
	page = 1,
	pageSize = 50
) => {
	const params = {
		documentCategoryName,
		filteredEntityIdInt,
		filteredEntityType,
		documentTypeIdList,
		filteredEntityIdGuid,
		orderBy,
		includeComments,
		page,
		pageSize
	};

	const url = GetAllDocumentsUrl(engagementId, params);

	return {
		type: types.GET_ALL_SIMPLE_HELIX_DOCUMENTS,
		key: storeKey,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export function setLoadingState(storeKey, bodyId, isLoading) {
	return {
		type: types.SET_SIMPLE_HELIX_LOADING_STATE,
		stateKey: storeKey,
		bodyId: bodyId,
		isLoading: isLoading
	};
}

//<Notes>
export const getAllNotes = (storeKey, engagementId, someParams) => {
	const someUrl = '';

	return {
		type: types.GET_ALL_SIMPLE_HELIX_NOTES,
		key: storeKey,
		meta: {
			api: {
				someUrl,
				method: 'GET'
			}
		}
	};
};

export function showBoundingBoxes(bodyId, show) {
	return {
		type: types.SIMPLE_HELIX_BOUNDING_BOXES_SHOW,
		bodyId,
		show
	};
}

export function newAnnotationSave(bodyId, annotation, isEditing = 0) {
	return {
		type: types.NEW_ANNOTATION_SAVE,
		bodyId,
		annotation,
		isEditing
	};
}

export function addBoundingBoxAnnotation(
	engagementId,
	bodyId,
	annotationId,
	documentId,
	boundingBoxData,
	referenceNumber,
	text
) {
	const apiUrl = patchAnnotationUrl(engagementId);
	const apiPayload = {
		referenceNumber,
		comments: text,
		ids: [annotationId],
		updateAction: updateAnnotationAction.editAnnotation,
		documentId,
		annotationAttribute: boundingBoxData && JSON.stringify(boundingBoxData)
	};
	const actionPayload = {
		bodyId,
		annotationId,
		text,
		referenceNumber,
		boundingBoxData
	};
	return createApiAction(types.ADD_BOUNDINGBOX_ANNOTATION, apiUrl, 'PUT', apiPayload, undefined, actionPayload);
}

export function setNewAnnotationBoundingBox(bodyId, boundingBox) {
	return {
		type: types.SET_NEW_ANNOTATION_BOUNDING_BOX,
		bodyId,
		boundingBox
	};
}

export function removeNewAnnotation(bodyId) {
	return {
		type: types.REMOVE_NEW_ANNOTATION,
		bodyId
	};
}

export function cancelBoundingBox(bodyId) {
	return {
		type: types.CANCEL_BOUNDING_BOX,
		bodyId
	};
}

export function setReferenceNumberNewAnnotation(referenceNumber, bodyId) {
	return {
		type: types.SET_REFERENCE_NUMBER_NEW_ANNOTATION,
		referenceNumber,
		bodyId
	};
}

export function getScreenshotBlob(engagementId, documentId, bodyId) {
	const apiUrl = `${env.getDocServiceUrl('documents.json')}/${documentId}/base64`;

	const apiAction = createApiAction(
		types.GET_SIMPLE_HELIX_DOCUMENT_BLOB,
		apiUrl,
		'GET',
		undefined,
		undefined,
		undefined,
		{EngagementId: engagementId}
	);

	apiAction.documentId = documentId;
	apiAction.bodyId = bodyId;

	return apiAction;
}

export function clearUploadedScreenshotData(bodyId) {
	return {
		type: types.CLEAR_UPLOADED_SCREENSHOT_DOCUMENT_ID,
		bodyId
	};
}

export function editAnnotation(
	engagementId,
	bodyId,
	annotationId,
	referenceNumber,
	text,
	documentId,
	annotationAttribute,
	updateAction = 5,
	type = types.EDIT_ANNOTATION
) {
	const apiUrl = patchAnnotationUrl(engagementId);
	const data = {
		ids: [annotationId],
		referenceNumber,
		comments: text,
		updateAction,
		documentId,
		annotationAttribute
	};

	const apiAction = createApiAction(type, apiUrl, 'PUT', data, undefined, {
		bodyId,
		annotationId,
		text,
		referenceNumber,
		annotationAttribute
	});
	return apiAction;
}

export function deleteAnnotation(engagementId, annotationId) {
	const apiUrl = deleteAnnotationUrl(engagementId, annotationId);

	const apiAction = createApiAction(types.DELETE_ANNOTATION, apiUrl, 'DELETE');
	return apiAction;
}

export function deleteScreenshot(engagementId, screenshotDocumentId) {
	const apiUrl = deleteDocumentUrl(engagementId, screenshotDocumentId);
	const apiAction = createApiAction(types.DELETE_DOCUMENT_SCREENSHOT, apiUrl, 'DELETE');

	return apiAction;
}
//</Notes>
